import { Component, inject, ChangeDetectionStrategy, OnInit } from "@angular/core";
import { AuthService } from "../auth.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Unsub } from "src/app/shared/unsub.class";
import { RouterModule } from "@angular/router";
import { AuthFormsService } from "src/app/shared/service/login-register-forms.service";

@Component({
    imports: [CommonModule, FormsModule, RouterModule],
    selector: "app-reset-password-request",
    templateUrl: "./forgot-password-request.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./forgot-password-request.component.css"]
})
export class ForgotPasswordRequestComponent extends Unsub implements OnInit {
  email: string = "";
  info: string = "";
  errorMsg: string = "";

  RequestSent: boolean = false;
  requestError: boolean = false;
  btnDisabled: boolean = false;
  loading: boolean = false;
  requestSuccess: boolean = false;
  authService = inject(AuthService);
  authFormsService = inject(AuthFormsService);

  ngOnInit(): void {
    this.authFormsService.showForgetPasswordForm();
  }

  // Send request to reset password
  submitResetPasswordRequest() {
    this.btnDisabled = true;
    this.requestError = false;
    this.requestSuccess = false;
    this.loading = true;
    const regex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    const match = regex.test(this.email);
    if (!match) {
      this.requestError = true;
      this.errorMsg = "Ogiltlig e-postadress";
      this.btnDisabled = false;
      return;
    }
    this.authService.sendResetPasswordRequest(this.email).subscribe({
      next: (res) => {
        this.loading = true;
        this.RequestSent = true;
        this.btnDisabled = false;
      },
      error: (error) => {
         this.loading = false;
        this.btnDisabled = false;
        this.requestError = true;
        this.errorMsg = "Ett oväntat fel upstod, vänligen försök igen";
      }
    });

  }
}
